/**
 * @generated SignedSource<<9d011e55b9734eb2fe45f55ae78a1a69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeQuery_Query$variables = Record<PropertyKey, never>;
export type HomeQuery_Query$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"Home_viewer">;
  } | null | undefined;
};
export type HomeQuery_Query = {
  response: HomeQuery_Query$data;
  variables: HomeQuery_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 10000
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pickup",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pickupStart",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pickupStreet",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pickupZip",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadline",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "owed",
  "storageKey": null
},
v10 = [
  (v0/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qty",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clearanceItemId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "specialItemId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddToCart",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOutOfStock",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVariable",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "package",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pack",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sizeUnit",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availability",
  "storageKey": null
},
v27 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v28 = {
  "alias": null,
  "args": [
    (v27/*: any*/)
  ],
  "concreteType": "ImageConnection",
  "kind": "LinkedField",
  "name": "images",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "images(first:100)"
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v13/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v8/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v28/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    [
      "id",
      "ASC"
    ]
  ]
},
v31 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrderEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v32 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0
},
v33 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 8
  },
  (v32/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      [
        "products.rank",
        "ASC"
      ]
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Home_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HomeQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filterBy",
                "value": {
                  "isActive": true,
                  "parentId": 0
                }
              },
              (v0/*: any*/)
            ],
            "concreteType": "CategoryConnection",
            "kind": "LinkedField",
            "name": "categories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "categories(filterBy:{\"isActive\":true,\"parentId\":0},first:10000)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Coop",
            "kind": "LinkedField",
            "name": "coop",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Cycle",
                "kind": "LinkedField",
                "name": "currentCycle",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pickupEnd",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveryStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "directions",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "freeShippingGoal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "freeShippingValue",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Cycle",
                "kind": "LinkedField",
                "name": "nextCycle",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Cycle",
                "kind": "LinkedField",
                "name": "nextCycles",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v6/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "credit",
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "owedReason",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Cart",
            "kind": "LinkedField",
            "name": "cart",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "CartItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CartItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CartItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:10000)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "SplitRequestConnection",
            "kind": "LinkedField",
            "name": "splitRequests",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SplitRequestEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SplitRequest",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v1/*: any*/),
                      (v15/*: any*/),
                      (v29/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "splitRequests(first:10000)"
          },
          {
            "alias": "unpaidOrders",
            "args": [
              {
                "kind": "Literal",
                "name": "filterBy",
                "value": {
                  "unpaid": true
                }
              },
              (v27/*: any*/),
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  [
                    "cycleId",
                    "DESC"
                  ]
                ]
              }
            ],
            "concreteType": "OrderConnection",
            "kind": "LinkedField",
            "name": "orders",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Order",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v15/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "orders(filterBy:{\"unpaid\":true},first:100,orderBy:[[\"cycleId\",\"DESC\"]])"
          },
          {
            "alias": "currentOrders",
            "args": [
              {
                "kind": "Literal",
                "name": "filterBy",
                "value": {
                  "cycleId": "current"
                }
              },
              (v0/*: any*/),
              (v30/*: any*/)
            ],
            "concreteType": "OrderConnection",
            "kind": "LinkedField",
            "name": "orders",
            "plural": false,
            "selections": (v31/*: any*/),
            "storageKey": "orders(filterBy:{\"cycleId\":\"current\"},first:10000,orderBy:[[\"id\",\"ASC\"]])"
          },
          {
            "alias": "pastOrders",
            "args": [
              {
                "kind": "Literal",
                "name": "filterBy",
                "value": {
                  "cycleId": "past"
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              (v30/*: any*/)
            ],
            "concreteType": "OrderConnection",
            "kind": "LinkedField",
            "name": "orders",
            "plural": false,
            "selections": (v31/*: any*/),
            "storageKey": "orders(filterBy:{\"cycleId\":\"past\"},first:1,orderBy:[[\"id\",\"ASC\"]])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filterBy",
                "value": {
                  "isActive": true,
                  "isAvailable": true,
                  "slug": "reorder"
                }
              },
              {
                "kind": "Literal",
                "name": "limit",
                "value": 12
              },
              (v32/*: any*/),
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  [
                    "rank",
                    "ASC"
                  ]
                ]
              }
            ],
            "concreteType": "ProductConnection",
            "kind": "LinkedField",
            "name": "products",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v13/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v8/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rank",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "products(filterBy:{\"isActive\":true,\"isAvailable\":true,\"slug\":\"reorder\"},limit:12,offset:0,orderBy:[[\"rank\",\"ASC\"]])"
          },
          {
            "alias": null,
            "args": (v33/*: any*/),
            "concreteType": "ClearanceItemConnection",
            "kind": "LinkedField",
            "name": "clearanceItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClearanceItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClearanceItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v1/*: any*/),
                      (v29/*: any*/),
                      (v11/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "clearanceItems(limit:8,offset:0,orderBy:[[\"products.rank\",\"ASC\"]])"
          },
          {
            "alias": null,
            "args": (v33/*: any*/),
            "concreteType": "SpecialItemConnection",
            "kind": "LinkedField",
            "name": "specialItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SpecialItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SpecialItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v1/*: any*/),
                      (v29/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "specialItems(limit:8,offset:0,orderBy:[[\"products.rank\",\"ASC\"]])"
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a9194444ca70efbc5428f35c4ce3453",
    "id": null,
    "metadata": {},
    "name": "HomeQuery_Query",
    "operationKind": "query",
    "text": "query HomeQuery_Query {\n  viewer {\n    ...Home_viewer\n    id\n  }\n}\n\nfragment DeliveryStatus_viewer on Viewer {\n  coop {\n    currentCycle {\n      pickup\n      pickupStart\n      pickupEnd\n      pickupStreet\n      pickupZip\n      deliveryStatus\n      directions\n      id\n    }\n    nextCycle {\n      pickup\n      pickupStart\n      pickupStreet\n      pickupZip\n      id\n    }\n    id\n  }\n  user {\n    role\n    id\n  }\n}\n\nfragment HomeCategories_viewer on Viewer {\n  categories(first: 10000, filterBy: {isActive: true, parentId: 0}) {\n    edges {\n      node {\n        name\n        slug\n        id\n      }\n    }\n  }\n}\n\nfragment Home_viewer on Viewer {\n  ...HomeCategories_viewer\n  ...Tabs_viewer\n}\n\nfragment MySplits_viewer on Viewer {\n  ...ProductItem_viewer\n  cart {\n    ...ProductItem_cart\n    items(first: 10000) {\n      edges {\n        node {\n          ...ProductItem_cartItem\n          clearanceItemId\n          productId\n          specialItemId\n          id\n        }\n      }\n    }\n    id\n  }\n  splitRequests(first: 10000) {\n    edges {\n      node {\n        clearanceItemId\n        id\n        rowId\n        product {\n          ...ProductItem_product\n          fullName\n          id\n          productId\n        }\n        specialItemId\n        user {\n          id\n          firstName\n          fullName\n        }\n      }\n    }\n  }\n  user {\n    id\n  }\n}\n\nfragment OrderDates_viewer on Viewer {\n  coop {\n    timezone\n    currentCycle {\n      freeShippingGoal\n      freeShippingValue\n      deadline\n      pickup\n      pickupStart\n      pickupEnd\n      pickupStreet\n      pickupZip\n      id\n    }\n    nextCycles {\n      id\n      deadline\n      pickup\n    }\n    id\n  }\n  user {\n    role\n    id\n  }\n}\n\nfragment PayMyBill_viewer on Viewer {\n  unpaidOrders: orders(filterBy: {unpaid: true}, first: 100, orderBy: [[\"cycleId\", \"DESC\"]]) {\n    edges {\n      node {\n        id\n        rowId\n        owed\n      }\n    }\n  }\n  currentOrders: orders(first: 10000, filterBy: {cycleId: \"current\"}, orderBy: [[\"id\", \"ASC\"]]) {\n    edges {\n      node {\n        id\n        rowId\n        createdAt\n      }\n    }\n  }\n  pastOrders: orders(first: 1, filterBy: {cycleId: \"past\"}, orderBy: [[\"id\", \"ASC\"]]) {\n    edges {\n      node {\n        id\n        rowId\n        createdAt\n      }\n    }\n  }\n  user {\n    credit\n    owed\n    owedReason\n    id\n  }\n}\n\nfragment ProductItem_cart on Cart {\n  id\n}\n\nfragment ProductItem_cartItem on CartItem {\n  id\n  qty\n}\n\nfragment ProductItem_product on Product {\n  id\n  productId\n  canAddToCart\n  isOutOfStock\n  isVariable\n  fullName\n  package\n  pack\n  size\n  sizeUnit\n  state\n  unit\n  cost\n  availability\n  images(first: 100) {\n    edges {\n      node {\n        url\n        id\n      }\n    }\n  }\n}\n\nfragment ProductItem_viewer on Viewer {\n  user {\n    id\n    role\n    email\n    firstName\n    fullName\n  }\n}\n\nfragment Reorder_viewer on Viewer {\n  ...ProductItem_viewer\n  cart {\n    ...ProductItem_cart\n    items(first: 10000) {\n      edges {\n        node {\n          ...ProductItem_cartItem\n          clearanceItemId\n          productId\n          specialItemId\n          id\n        }\n      }\n    }\n    id\n  }\n  products(limit: 12, offset: 0, filterBy: {slug: \"reorder\", isActive: true, isAvailable: true}, orderBy: [[\"rank\", \"ASC\"]]) {\n    edges {\n      node {\n        ...ProductItem_product\n        cost\n        fullName\n        id\n        rank\n        unit\n      }\n    }\n  }\n}\n\nfragment Tabs_viewer on Viewer {\n  ...DeliveryStatus_viewer\n  ...MySplits_viewer\n  ...OrderDates_viewer\n  ...PayMyBill_viewer\n  ...Reorder_viewer\n  ...WhatsOnSale_viewer\n  coop {\n    currentCycle {\n      deadline\n      pickup\n      id\n    }\n    id\n  }\n  user {\n    role\n    id\n  }\n}\n\nfragment WhatsOnSale_viewer on Viewer {\n  ...ProductItem_viewer\n  cart {\n    ...ProductItem_cart\n    items(first: 10000) {\n      edges {\n        node {\n          ...ProductItem_cartItem\n          clearanceItemId\n          productId\n          specialItemId\n          id\n        }\n      }\n    }\n    id\n  }\n  clearanceItems(limit: 8, offset: 0, orderBy: [[\"products.rank\", \"ASC\"]]) {\n    edges {\n      node {\n        cost\n        id\n        product {\n          id\n          ...ProductItem_product\n        }\n        qty\n        unit\n      }\n    }\n  }\n  specialItems(limit: 8, offset: 0, orderBy: [[\"products.rank\", \"ASC\"]]) {\n    edges {\n      node {\n        cost\n        id\n        product {\n          id\n          ...ProductItem_product\n        }\n        unit\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e68dfca8813de9ded3ca739d6fc48a59";

export default node;
